import { TopListTableNames } from '@/models/top-list/top-list-table-names.model';

export const TOP_LIST_TABLE_NAME_LIST: TopListTableNames[] = [
  TopListTableNames.TOP_WINS,
  TopListTableNames.TOP_WINNERS,
  TopListTableNames.TOP_LOSERS,
];
